// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageTitleCountStyles } from "@conklin/App/Components/Common/PageTitleCount";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

pageTitleCountStyles.container = {
    css: css`
        ${getProp("theme.typography.h1.css")};
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        column-gap: 24px;
        row-gap: 12px;
    `,
};
pageTitleCountStyles.pageTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

pageTitleCountStyles.productCountText = {
    variant: "h5",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
